// Translations
import tosDialog from '../components/tos-dialog/translations/ua'

// Translation: Register > Landing > Form (Ukrainian)
export default Object.freeze({
	components: { tosDialog },
	form: {
		actions: {
			continue: '',
			register: ''
		},
		fields: {
			email: {
				placeholder: ''
			},
			firstName: {
				placeholder: ''
			},
			lastName: {
				placeholder: ''
			},
			password: {
				placeholder: ''
			},
			passwordConfirmation: {
				placeholder: ''
			}
		},
		options: {
			login: {
				action: '',
				label: ''
			}
		},
		title: {
			accountInformation: '',
			profileDetails: ''
		}
	}
})
